module.exports = __webpack_public_path__ + "static/media/active.69b9e649.logo";